import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Laptop = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M4 16V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5 16h14M2 16h20v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.25 6A2.75 2.75 0 0 1 6 3.25h12A2.75 2.75 0 0 1 20.75 6v9.25H22a.75.75 0 0 1 .75.75v2A2.75 2.75 0 0 1 20 20.75H4A2.75 2.75 0 0 1 1.25 18v-2a.75.75 0 0 1 .75-.75h1.25zm-.5 10.75V18c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25v-1.25z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
